// eslint-disable-next-line
function populateErrorMessages(messages, element) {
    // eslint-disable-next-line
    messages[`${element.attr('name')}`] = {};
    // eslint-disable-next-line
    messages[`${element.attr('name')}`]['required'] = element.data('missing-error');
}
module.exports = populateErrorMessages;
